export default "__VITE_ASSET__6c9129aa__"